import * as React from "react";
import {ReactElement, useState} from "react";
import {connect} from "react-redux";
import {Box, Button, styled, TextField, Typography} from "@mui/material";
import {IPageProps} from "../interfaces/components/props/IPageProps";
import {emailJsPublicKey, emailJsServiceId, emailJsTemplateId} from "../Config";
import {RootState} from "../redux/store";
import {AlertType, setAlert} from "../redux/slice/alertSlice";
import {ILanguageTokens} from "../localization/LanguageTokens";
import {ITheme} from "../interfaces/themes/ITheme";
import emailjs from '@emailjs/browser';

const Root = styled(Box)(({theme}) => ({
    minHeight: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1',
}));

const Header = styled(Typography)(({theme}) => ({
    textAlign: 'center',
}));

const Info = styled(Typography)(({theme}) => ({
    textAlign: 'center',
    color: theme.palette.text.primary,
    paddingBottom: theme.spacing(1),
}));

// @ts-ignore todo
const FormCol = styled(Box)(({theme}: { theme: ITheme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    justifyContent: 'center',
    flex: 1,
}));

interface IProps extends IPageProps {
    languageTokens: ILanguageTokens;
    setAlert: ({alertOpen, alertType, alertText}: {
        alertOpen: boolean,
        alertType: AlertType,
        alertText: string
    }) => void;
}

interface IState {
    name: string;
    email: string;
    subject: string;
    message: string;
}

const initialState: IState = {
    name: "",
    email: "",
    subject: "",
    message: "",
}

function Contact(props: IProps): ReactElement {
    const {languageTokens} = props;

    const [state, setState] = useState<IState>(initialState);

    const handleSendEmail = (e) => {
        e.preventDefault();

        const {setAlert, languageTokens} = props;

        emailjs.send(emailJsServiceId, emailJsTemplateId, {...state}, {
            publicKey: emailJsPublicKey,
        }).then(
            function (response) {
                console.log('SUCCESS!', response.status, response.text);
                setAlert({alertOpen: true, alertType: 'success', alertText: languageTokens.sendingEmailSuccessful});
                setState(initialState);
            },
            function (error) {
                setAlert({alertOpen: true, alertType: 'error', alertText: error.text});
                console.log('FAILED...', error);
            },
        );
    };

    const handleChange = (event) => {
        const {name, value} = event.target;
        setState({...state, [name]: value})
    }


    return (
        <Root id='Contact'>
            <Header
                gutterBottom
                variant="h1"
                pt={8}
            >{languageTokens.Contact}</Header>
            <Info
                variant="h6"
                color="textSecondary"
                // todo remove ? component="p"
                gutterBottom
            >
                {languageTokens.contactMeInfo}
            </Info>
            <form
                id={'contactForm'}
                onSubmit={handleSendEmail}
                style={{display: 'flex', justifyContent: 'center', width: '100%'}}
            >
                <FormCol maxWidth={'sm'}>

                <TextField
                    name={"name"}
                    placeholder={languageTokens.EnterName}
                    variant="outlined"
                    required
                    value={state.name}
                    onChange={handleChange}
                />
                <TextField
                    name={"email"}
                    type="email"
                    placeholder={languageTokens.EnterEmail}
                    variant="outlined"
                    required
                    value={state.email}
                    onChange={handleChange}
                />
                <TextField
                    name={"subject"}
                    placeholder={languageTokens.EnterSubject}
                    variant="outlined"
                    required
                    value={state.subject}
                    onChange={handleChange}
                />
                <TextField
                    name={"message"}
                    multiline
                    rows={4}
                    placeholder={languageTokens.TypeYourMessageHere}
                    variant="outlined"
                    required
                    value={state.message}
                    onChange={handleChange}
                />
                <Button
                    aria-label="Submit"
                    type="submit"
                    variant="contained"
                    size={"large"}
                    sx={{textTransform: 'none', fontSize: 20, top: 24}}
                >
                    {languageTokens.SUBMIT}
                </Button>
                </FormCol>
            </form>
        </Root>
    );
}

const mapStateToProps = (state: RootState) => ({
    languageTokens: state.language.languageTokens,
});

const mapActionsToProps = {
    setAlert: setAlert,
};

export default connect(mapStateToProps, mapActionsToProps)(Contact);
